import React, { useState, useEffect } from "react";
import About from "./About";
import Contact from "./Contact";
import Projects from "./Projects";
import SideBar from "../components/SideBar";
import Resume from "./Resume";
import MobileMenu from "../components/MobileMenu";
import Header from "../components/Header";
import NavBar from "../components/NavBar";
import { ChevronRightIcon } from "@heroicons/react/solid";

const Home = () => {
  const [activeTab, setActiveTab] = useState("home");
  const [sidebarWidth, setSidebarWidth] = useState(270);

  useEffect(() => {
    const savedWidth = localStorage.getItem("sideBarWidth");
    if (savedWidth) {
      setSidebarWidth(parseInt(savedWidth));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("sideBarWidth", sidebarWidth.toString());
  }, [sidebarWidth]);

  const getFileName = () => {
    switch (activeTab) {
      case "home": return "Home.tsx";
      case "about": return "About.tsx";
      case "resume": return "Resume.tsx";
      case "projects": return "Projects.tsx";
      case "contact": return "Contact.tsx";
      default: return "Home.tsx";
    }
  };

  const renderComponent = () => {
    switch (activeTab) {
      case "home":
        return (
          <div>
            <Header setActiveTab={setActiveTab} />
            <About />
            <Resume />
            <Projects />
            <Contact />
          </div>
        );
      case "about":
        return <About />;
      case "resume":
        return <Resume />;
      case "projects":
        return <Projects />;
      case "contact":
        return <Contact />;
      default:
        return (
          <div>
            <Header setActiveTab={setActiveTab} />
            <About />
            <Resume />
            <Projects />
            <Contact />
          </div>
        );
    }
  };

  return (
    <div id="home" className="App flex flex-col h-screen overflow-hidden">
      {/* VS Code Title Bar */}
      <div className="h-8 bg-[#323233] hidden lg:flex items-center justify-center text-[#cccccc] text-sm select-none flex-shrink-0">
        <div className="flex items-center gap-2">
          <span className="text-[#007acc]">●</span>
          <span>Manan Sharma - Portfolio</span>
          <span className="text-[#858585]">— Visual Studio Code</span>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar - Fixed */}
        <div
          className="bg-[#252526] h-full hidden lg:block flex-shrink-0"
          style={{ width: `${sidebarWidth}px` }}
        >
          <SideBar
            setWidth={setSidebarWidth}
            width={sidebarWidth}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>

        {/* Right Side - Editor Area */}
        <div className="flex-1 flex flex-col overflow-hidden bg-[#1e1e1e]">
          {/* Mobile Menu */}
          <div className="lg:hidden">
            <MobileMenu activeTab={activeTab} setActiveTab={setActiveTab} />
          </div>

          {/* Tab Bar */}
          <div className="h-[35px] hidden lg:block flex-shrink-0 bg-[#252526]">
            <NavBar activeTab={activeTab} setActiveTab={setActiveTab} />
          </div>

          {/* Breadcrumb Bar */}
          <div className="h-6 bg-[#1e1e1e] hidden lg:flex items-center px-4 text-xs text-[#858585] border-b border-[#252526] flex-shrink-0">
            <span className="text-[#cccccc]">portfolio</span>
            <ChevronRightIcon className="w-3 h-3 mx-1" />
            <span className="text-[#cccccc]">src</span>
            <ChevronRightIcon className="w-3 h-3 mx-1" />
            <span className="text-[#cccccc]">pages</span>
            <ChevronRightIcon className="w-3 h-3 mx-1" />
            <span className="text-[#e8ab53]">{getFileName()}</span>
          </div>

          {/* Editor Content - Scrollable */}
          <div className="flex-1 overflow-auto">
            {renderComponent()}
          </div>

          {/* Bottom Status Bar */}
          <div className="h-6 bg-[#007acc] hidden lg:flex items-center justify-between px-3 text-white text-xs flex-shrink-0">
            <div className="flex items-center gap-4">
              <span>⚡ main</span>
              <span>↻ 0</span>
              <span>⚠ 0</span>
            </div>
            <div className="flex items-center gap-4">
              <span>Ln 1, Col 1</span>
              <span>Spaces: 2</span>
              <span>UTF-8</span>
              <span>TypeScript React</span>
              <span>Prettier</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
